//import logo from './logo.svg';
import logo from './logo.png';

export const settings = {
    "title": "Bezze CRM",
    "apiUrl": "https://api.crm.bezze.it/api",
    "ckdPath": "https://api.crm.bezze.it/",
    "tinyKey": "uxd8thxx2a96p0tne20wyfcdx7zvpyprm38j5q5w9qqauy2p",
    "googleMapKey": "AIzaSyDwVSRwXezXuTLG8-VAe1KfNKo7zLPlYJQ",
    "config": {
        "limit": 50,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "supplier": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "sales_agent": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        }
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "logo": logo,
    "data_print": {
        "name": 'Bezze Lucio Sas di Franco Bezze & C',
        "address": 'Via Romea, 42/44 - 35020 Legnaro (PD) IT',
        "phone": 'Tel: 049 8791234',
        "fax": '',
        "email": 'Email: info@bezze.it',
        "iva": 'P.IVA: IT00973570286',
        "cf": '',
        "website": 'Sito Web: www.bezze.it'
    },
    "stampe" : {
       "arredatore": true, 
       "sconto": true, 
       "listino": true, 
       "condVendita": true, 
       "firmaVenditore": true
    },
    "dati_pagamento": {
        "iban": "IT54K0880762881000000278851",
        "banca": "BCC VENETA Credito Cooperativo Soc. Coop.",
        "intestatario": "Bezze Lucio Sas",
    },
    "iva_label": 'inclusa',
    "iva_esclusa": false,
    "sconti": true
}